// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__iQxLb","hasContent":"style_hasContent__HNZMR","closeIcon":"style_closeIcon__WH1j3"};